import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function About() {
  const teamImage = 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/3c7718da-c622-4e09-b9ce-f749a5967f74/power-multiservice-cleaning-team.png';

  return (
    <div>
      <SEO
        title="Om os - Power-Multiservice"
        description="Læs om Power-Multiservice – din pålidelige partner inden for kvalitetsrengøring til både private hjem og erhverv."
        path="/om-os"
      />

      {/* HERO / INTRO */}
      <section className="bg-white py-12 sm:py-20 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center space-y-4 animate-fade-in-up">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight">
              Kvalitetsrengøring med fokus på grundighed og tillid
            </h1>
            <p className="text-base sm:text-lg text-slate-600 leading-relaxed">
              Power-Multiservice er en dedikeret rengøringsvirksomhed med base i Nørre Aaby. Vi servicerer både private boligejere og virksomheder med skræddersyede rengøringsaftaler.
            </p>
          </div>
        </div>
      </section>

      {/* DETALJERET PRÆSENTATION */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            
            <div className="lg:col-span-6 space-y-6 animate-fade-in-up">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                Enkel, ærlig og grundig rengøringsservice
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Hos Power-Multiservice lægger vi vægt på den direkte og personlige dialog. Når du indgår en aftale med os, ved du præcis, hvad der bliver gjort, og hvornår det bliver gjort.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Vi benytter professionelle rengøringsredskaber og effektive midler, der sikrer et rent og hygiejnisk resultat, uanset om det gælder et privat hjem eller et travlt kontor.
              </p>

              <div className="space-y-3 pt-2">
                <div className="flex items-start gap-3 hover:translate-x-1 transition-transform duration-200">
                  <span className="text-emerald-600 flex items-center justify-center text-sm shrink-0 mt-0.5">
                    <i className="fa-solid fa-check" aria-hidden="true" />
                  </span>
                  <p className="text-sm text-slate-700 font-medium">
                    Fleksible rengøringsplaner tilpasset dit skema
                  </p>
                </div>
                <div className="flex items-start gap-3 hover:translate-x-1 transition-transform duration-200">
                  <span className="text-emerald-600 flex items-center justify-center text-sm shrink-0 mt-0.5">
                    <i className="fa-solid fa-check" aria-hidden="true" />
                  </span>
                  <p className="text-sm text-slate-700 font-medium">
                    Stor omhu ved håndtering af dine lokaler og inventar
                  </p>
                </div>
                <div className="flex items-start gap-3 hover:translate-x-1 transition-transform duration-200">
                  <span className="text-emerald-600 flex items-center justify-center text-sm shrink-0 mt-0.5">
                    <i className="fa-solid fa-check" aria-hidden="true" />
                  </span>
                  <p className="text-sm text-slate-700 font-medium">
                    Hurtig og gennemskuelig tilbudsproces
                  </p>
                </div>
              </div>

              <div className="pt-4">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-bold text-sm sm:text-base text-slate-950 bg-emerald-400 hover:bg-emerald-300 hover:scale-[1.02] active:scale-[0.98] transition-all duration-200"
                >
                  <span>Kontakt os for et tilbud</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                </Link>
              </div>
            </div>

            <div className="lg:col-span-6 animate-fade-in-up delay-100">
              <div className="group overflow-hidden">
                <img
                  src={teamImage}
                  alt="Power-Multiservice rengøringsteam"
                  className="w-full h-80 sm:h-96 object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}
